import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { MinimalButton } from '@calendly/ui/components/minimal-button'
import { Body, Footer, Popup } from '@calendly/ui/components/popup'
import { useDispatch } from 'react-redux'

import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'
import { useTrack } from 'hooks/analytics_events/useTrack'

import { resetPopup } from './slice'

const BillingEmailLink = () => {
  const track = useTrack()

  const billingEmail = 'billing@calendly.com'

  const handleEmailBilling = () => {
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      properties: {
        cta_destination: 'mailto_billing',
        cta_key: 'billing_page_billing_information',
        cta_text: billingEmail
      }
    })
    window.location.href = `mailto:${billingEmail}`
  }

  return (
    <MinimalButton onClick={handleEmailBilling}>
      {billingEmail}
    </MinimalButton>
  )
}

export const TaxInformationDeleteModal = () => {
  const dispatch = useDispatch()

  return (
    <Popup
      onClose={() => {}}
      size="small"
      title={I18n.t('publisher.billing.vat_id_popup.delete_popup.title')}
    >
      <Body>
        {HtmlParser(I18n.t('publisher.billing.vat_id_popup.delete_popup.text'), { BillingEmailLink })}
      </Body>
      <Footer>
        <Button
          onClick={() => {
            dispatch(resetPopup())
          }}
        >
          {I18n.t('publisher.billing.vat_id_popup.delete_popup.ok')}
        </Button>
      </Footer>
    </Popup>
  )
}
